import 'babel-polyfill';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import RouterComponent from './router';
import * as serviceWorker from './serviceWorker';
import { createStore,combineReducers } from 'redux';
import { Provider } from 'react-redux';

//2、商品装车
function counterReducer(state={amount:0},action){
    //console.log(action);
    switch (action.type) {
        case "inc":
            return Object.assign({},state,{amount:action.amount});
        case "dec":
            return Object.assign({},state,{amount:action.amount});
        default:
            return state;
    }

}
let userLoginState={nickname:localStorage['nickname']!==undefined?localStorage['nickname']:'',isLogin:localStorage['isLogin']!==undefined?Boolean(localStorage['isLogin']):false};
function userLoginReducer(state=userLoginState,action){
    //console.log(action);
    switch (action.type) {
        case "login":
            return Object.assign({},state,{nickname:action.nickname,isLogin:action.isLogin})
        default:
            return state;
    }
}
let reducers=combineReducers(
    {
        counter:counterReducer,
        userLogin:userLoginReducer
    }
)
//3、存入仓库
let store=createStore(reducers);
class Index extends React.Component{
    render(){
        return(
            <React.Fragment>
                {/*将仓库的值分配到所有组件*/}
                <Provider store={store}>
                    <RouterComponent></RouterComponent>
                </Provider>
            </React.Fragment>
        )
    }
}

ReactDOM.render(<Index />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
